import template from './neti-powered-by.twig';
import './neti-powered-by.scss'

Shopware.Component.register('neti-next-incomplete-order-reminder-powered-by', {
    template,

    props: {
        pluginName: {
            type: String,
            required: true
        }
    },

    computed: {
        pluginLink() {
            return 'https://redirect.netinventors.de/de/' + this.pluginName + '/kaufen';
        }
    }
});
